import { CObject, CPrimitive } from "../constructions";
import { Collab } from "../core";
/**
 * This mixin adds default implementations of CSet
 * methods to an arbitrary Collab base class.
 * You may override the default implementations.
 *
 * Implemented methods: clear, forEach, Symbol.iterator
 *
 * Due to limitations of TypeScript, this version of the
 * function sets all of Base's generic type parameters to their
 * base type constraint (e.g., {} if they are unconstrained).
 * If you want to override this, you must make an unsafe
 * cast to the intended constructor type, as demonstrated
 * by [[AbstractCSetCObject]] and the other examples
 * in this file.
 */
export function MakeAbstractCSet(Base) {
    // @ts-expect-error generics in mixins are not supported
    class Mixin extends Base {
        constructor(...args) {
            super(...args);
        }
        clear() {
            for (const value of this)
                this.delete(value);
        }
        forEach(callbackfn, thisArg // eslint-disable-line @typescript-eslint/no-explicit-any
        ) {
            // Not sure if this gives the exact same semantics
            // as Set if callbackfn modifies this during the
            // loop.  (Given that Array.forEach has a rather
            // funky polyfill on MDN, I expect Set.forEach is
            // similarly funky.)  Although users probably shouldn't
            // be doing that anyway.
            for (const value of this) {
                callbackfn.call(thisArg, value, value, this);
            }
        }
        [Symbol.iterator]() {
            return this.values();
        }
        toString() {
            return [...this].toString();
        }
    }
    // eslint-disable-next-line
    return Mixin;
}
export const AbstractCSetCObject = MakeAbstractCSet(CObject);
export const AbstractCSetCPrimitive = MakeAbstractCSet(CPrimitive);
export const AbstractCSetCollab = MakeAbstractCSet(Collab);
//# sourceMappingURL=abstract_set.js.map